import {
  graphql
} from "./chunk-UDCSZ4EW.mjs";

// src/graphql/definitions/queries.ts
var getAvailableAgentsQuery = graphql(
  /** GraphQL **/
  `
  query availableAgents {
    availableAgents {
      agents {
        name
        id
        description
      }
    }
  }
`
);
var loadAgentStateQuery = graphql(
  /** GraphQL **/
  `
  query loadAgentState($data: LoadAgentStateInput!) {
    loadAgentState(data: $data) {
      threadId
      threadExists
      state
      messages
    }
  }
`
);

export {
  getAvailableAgentsQuery,
  loadAgentStateQuery
};
//# sourceMappingURL=chunk-OKPFKUUA.mjs.map